import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";

import { Can } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import "modules/DpoContract/DpoContract.scss";
import { useAcceptDpoContractMutation } from "modules/DpoContract/hooks";
import { useLogout } from "modules/Login/hooks";

const dpoContractLink = "https://storage.googleapis.com/claire-dpo-resources/GDPR-AVG-Claire.pdf";

export const DpoContract = () => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();
  const logout = useLogout();
  const { mutate: handleAcceptContract, isPending } = useAcceptDpoContractMutation();

  return (
    <div className="DpoContract">
      <div className="header">
        <div>{t("v8_accept_before_continuing", "Please accept the agreement before continuing to Claire")}</div>
      </div>

      <div className="content">
        <h1>
          {t("v8_claire_agreement", "Claire Automotive Support Agreement")}
          <span className="UserInfo">{`${user?.first_name ?? ""} ${user?.last_name ?? ""}`}</span>
        </h1>

        <div className="embeded-contract">
          <embed src={dpoContractLink} width="100%" height="100%" />
        </div>

        <div className="footer">
          <Button onClick={() => logout()} disabled={isPending} className="accept-button">
            {t("v8_decline_and_logout", "Decline and logout")}
          </Button>

          <Can I={ACL_ACTIVITIES.Update} the={ACL_RESOURCES.Agreements}>
            <Button color="green" onClick={() => handleAcceptContract()} loading={isPending} disabled={isPending} floated="right">
              {t("v8_accept_the_terms", "Accept the terms")}
            </Button>
          </Can>
        </div>
      </div>
    </div>
  );
};
